export default function getLoadBalancerReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_LOAD_BALANCER_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_LOAD_BALANCER_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_LOAD_BALANCER_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}